export default __webpack_public_path__ + "static/media/venhancer-after.e07e06b1.png";